define(['components/utilities/utilities'], function (utils) {
	'use strict';

	/**
	 * Anchor scroll
	 * A plugin that animates the scroll of an anchor-link.
	 * @exports anchorScroll
	 */
	var anchorScroll = {

		/**
		 * The initialization function for this module.
		 * @param {Object} els - An array of DOM nodes.
		 * @public
		 */
		init: function (els) {
			this._initEvents(els);
		},


		/**
		 * Init click event.
		 * @param {Object} els - An array of DOM nodes.
		 * @private
		 */
		_initEvents: function (els) {
			utils.forEach(els, function (el) {
				utils.addEventListener(el, 'click', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

					var targetId = el.getAttribute('href').split('#')[1],
						target = document.getElementById(targetId),
						scrollY = window.pageYOffset || document.documentElement.scrollTop,
						scrollToY;

					if (target !== null) {
						scrollToY = target.getBoundingClientRect().top + scrollY;
						utils.scrollToY(scrollToY, 1500, 'easeInOutQuint');
						setTimeout(function () {
							window.location.hash = '#' + targetId;
						}, 500);
					}
				});
			});
		}
	};


	return anchorScroll;
});


//////////////////
// WEBPACK FOOTER
// ./components/anchorScroll/anchorScroll.js
// module id = 64
// module chunks = 16